import { Observable } from '@reactivex/rxjs';
import FalcorRouter from '@graphistry/falcor-router';
import JSONGraphError from '@graphistry/falcor-router/src/errors/JSONGraphError';
import CallNotFoundError from '@graphistry/falcor-router/src/errors/CallNotFoundError';
import MaxPathsExceededError from '@graphistry/falcor-router/src/errors/MaxPathsExceededError';
import CallRequiresPathsError from '@graphistry/falcor-router/src/errors/CallRequiresPathsError';
let logger = require('@graphistry/logger')(module);
logger = logger.warn && logger.error ? logger : console; // fallback to console if undefined
const prettyPrintPaths = ((collapse) =>
    (paths) => collapse(paths).map((p) => JSON.stringify(p))
)(require('@graphistry/falcor-path-utils/lib/collapse'));

export function createAppRouter(env, routes) {
    const AppRouterBase = FalcorRouter.createClass(routes, env);
    return class AppRouter extends AppRouterBase {
        constructor(request = {}, requestConfig = {}) {
            super(requestConfig);
            this.request = request;
            const { debug, streaming, bufferTime, ...options } = requestConfig || {};
            for (const key in options) {
                this[key] = options[key];
            }
            this.routeUnhandledPathsTo({
                get(paths) {
                    logger.warn({ paths: prettyPrintPaths(paths) }, `Falcor-router unhandled get`);
                    return Observable.empty();
                },
                set(jsonGraphEnv) {
                    logger.warn({
                        paths: prettyPrintPaths(jsonGraphEnv.paths),
                        jsonGraph: jsonGraphEnv.jsonGraph
                    }, `Falcor-router unhandled set`);
                    return Observable.of(jsonGraphEnv);
                },
                call(callPath, args, refPaths, thisPaths) {
                    logger.warn({
                        args,
                        callPath: JSON.stringify(callPath),
                        refPaths: prettyPrintPaths(refPaths),
                        thisPaths: prettyPrintPaths(thisPaths)
                    }, `Falcor-router unhandled call`);
                }
            });
        }
        get(paths) {
            return super.get(paths).do(null, err => {
                if (
                    err instanceof JSONGraphError ||
                    err instanceof CallNotFoundError ||
                    err instanceof MaxPathsExceededError ||
                    err instanceof CallRequiresPathsError
                ) {
                    logger.error(
                        { requestType: 'get', err, paths: prettyPrintPaths(paths) },
                        `Falcor Router get error: ${(err && err.constructor.name) ||
                            'Unknown Error'}`
                    );
                } else {
                    logger.error({err, type: typeof(err)}, 'Other Falcor Router get error');
                }
            });
        }
        set(jsonGraphEnv) {
            return super.set(jsonGraphEnv).do(null, err => {
                if (
                    err instanceof JSONGraphError ||
                    err instanceof CallNotFoundError ||
                    err instanceof MaxPathsExceededError ||
                    err instanceof CallRequiresPathsError
                ) {
                    logger.error(
                        { requestType: 'set', err, jsonGraphEnv },
                        `Falcor Router set error: ${(err && err.constructor.name) ||
                            'Unknown Error'}`
                    );
                } else {
                    logger.error({err, type: typeof(err)}, 'Other Falcor Router set error');
                }
            });
        }
        call(callPath, args, refPaths, thisPaths) {
            return super.call(callPath, args, refPaths, thisPaths).do(null, err => {
                if (
                    err instanceof JSONGraphError ||
                    err instanceof CallNotFoundError ||
                    err instanceof MaxPathsExceededError ||
                    err instanceof CallRequiresPathsError
                ) {
                    logger.error(
                        { requestType: 'call', err, callPath, args, refPaths, thisPaths },
                        `Falcor Router call error: ${(err && err.constructor.name) ||
                            'Unknown Error'}`
                    );
                } else {
                    logger.error({err, type: typeof(err)}, 'Other Falcor Router call error');
                }
            });
        }
    };
}
